import React from 'react';
import { Button, Chip } from '@heroui/react';
import { Typography } from '../../../../components';
import { OrderActionType, OrderData } from '../types';
import { getStatusLabel } from '../utils';
import { useTranslations } from '../../../../contexts/translation.context';

interface StatusCellProps {
  order: OrderData;
  onOrderAction: (order: OrderData, actionType: OrderActionType) => void;
}

const StatusCell: React.FC<StatusCellProps> = ({ order, onOrderAction }) => {
  const { t } = useTranslations();
  const actionType: OrderActionType | null =
    order.status === 'in_progress' ? 'continue' : order.status === 'completed' ? 'repeat' : null;

  return (
    <div className="flex min-w-[11.25rem] flex-col items-start gap-2">
      <Chip
        className={`rounded-lg ${
          order.status === 'in_progress'
            ? 'bg-gray-100 text-gray-900'
            : order.status === 'pending'
              ? 'bg-gray-100 text-gray-900'
              : order.status === 'completed'
                ? 'bg-gray-100 text-gray-900'
                : order.status === 'not_started'
                  ? 'bg-gray-100 text-gray-900'
                  : order.status === 'canceled'
                    ? 'bg-gray-100 text-gray-900'
                    : 'bg-gray-100 text-gray-900 !h-6 px-2 py-1'
        }`}
        classNames={{
          base: 'h-6 px-2 py-1 gap-1',
        }}
        size="sm"
        startContent={
          <div
            className={`w-2 h-2 rounded-full ${
              order.status === 'in_progress'
                ? 'bg-blue-600'
                : order.status === 'pending'
                  ? 'bg-yellow-600'
                  : order.status === 'completed'
                    ? 'bg-green-600'
                    : order.status === 'not_started'
                      ? 'bg-auth-muted'
                      : order.status === 'canceled'
                        ? 'bg-auth-strength-weak'
                        : 'bg-gray-600'
            }`}
          ></div>
        }
      >
        <Typography variant="body3" className="text-gray-900">
          {getStatusLabel(order.status, t)}
        </Typography>
      </Chip>
      {actionType && (
        <Button
          size="sm"
          radius="sm"
          variant="flat"
          className="h-7 min-w-0 bg-partner/10 text-partner font-medium px-2.5"
          onPress={() => onOrderAction(order, actionType)}
        >
          {actionType === 'continue' ? t('orders.actions.continue') : t('orders.actions.repeat')}
        </Button>
      )}
    </div>
  );
};

export default StatusCell;
